module.exports = __webpack_public_path__ + "img/stockpools.67661e4b.jpg";